// src/components/sections/AboutSection.js
import React from 'react';

function AboutSection({ content }) {
  return (
    <section id="about" className="py-20 bg-white scroll-mt-16">
      <div className="container mx-auto px-6 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-8">About Us</h2>
        <p className="text-lg text-gray-700 leading-relaxed mb-0 text-justify">
          {/* Render content only if it exists */}
          {content || "About content loading..."}
        </p>
      </div>
    </section>
  );
}

export default AboutSection;
